import { Link } from 'react-router-dom';
import { games } from '@/mocks/games';

const featuredGames = games.filter((g) => g.featured);

export default function FeaturedGames() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            热门游戏推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选玩家评分最高的网页游戏，每一款都值得你花时间体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop>
          {featuredGames.map((game) => (
            <Link
              key={game.id}
              to={`/category/${game.category}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={game.image}
                  alt={game.name}
                  title={`${game.name} - 热门网页游戏推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 right-2 bg-background-950/75 backdrop-blur-sm text-background-50 text-xs px-2 py-1 rounded-full whitespace-nowrap">
                  <i className="ri-star-fill text-primary-400 mr-0.5"></i>
                  {game.rating}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                  {game.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                  {game.description}
                </p>
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  {game.tags.map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-800 rounded-full whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
                  <i className="ri-user-line"></i>
                  <span>{game.players} 玩家</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-500 text-background-50 rounded-full text-sm font-medium hover:bg-secondary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部游戏
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}